import {
  EquipmentDailyOperationReportStateTypes,
  EquipmentDailyOperationReportActionTypes,
} from "./EquipmentDailyOperationReport.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: EquipmentDailyOperationReportStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchPrevious: resetApiCallState({}),
  fetchReport: resetApiCallState({}),
};

const EquipmentDailyOperationReportReducer = (
  state: EquipmentDailyOperationReportStateTypes = INITIAL_STATE,
  action: any
): EquipmentDailyOperationReportStateTypes => {
  switch (action.type) {
    case EquipmentDailyOperationReportActionTypes.FETCH_ALL_EQUIPMENT_DAILY_OPERATION_REPORT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_ALL_EQUIPMENT_DAILY_OPERATION_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_ALL_EQUIPMENT_DAILY_OPERATION_REPORT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_ALL_EQUIPMENT_DAILY_OPERATION_REPORT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EquipmentDailyOperationReportActionTypes.FETCH_ONE_EQUIPMENT_DAILY_OPERATION_REPORT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_ONE_EQUIPMENT_DAILY_OPERATION_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_ONE_EQUIPMENT_DAILY_OPERATION_REPORT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_ONE_EQUIPMENT_DAILY_OPERATION_REPORT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EquipmentDailyOperationReportActionTypes.FETCH_PREVIOUS_EQUIPMENT_DAILY_OPERATION_REPORT:
      return {
        ...state,
        fetchPrevious: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_PREVIOUS_EQUIPMENT_DAILY_OPERATION_REPORT_RESET:
      return {
        ...state,
        fetchPrevious: resetApiCallState({}),
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_PREVIOUS_EQUIPMENT_DAILY_OPERATION_REPORT_FAILURE:
      return {
        ...state,
        fetchPrevious: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_PREVIOUS_EQUIPMENT_DAILY_OPERATION_REPORT_SUCCESS:
      return {
        ...state,
        fetchPrevious: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    //

    case EquipmentDailyOperationReportActionTypes.FETCH_GENERATED_EQUIPMENT_DAILY_OPERATION_REPORT:
      return {
        ...state,
        fetchReport: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_GENERATED_EQUIPMENT_DAILY_OPERATION_REPORT_RESET:
      return {
        ...state,
        fetchReport: resetApiCallState({}),
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_GENERATED_EQUIPMENT_DAILY_OPERATION_REPORT_FAILURE:
      return {
        ...state,
        fetchReport: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentDailyOperationReportActionTypes.FETCH_GENERATED_EQUIPMENT_DAILY_OPERATION_REPORT_SUCCESS:
      return {
        ...state,
        fetchReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EquipmentDailyOperationReportReducer;
